import { reactive } from "@vue/composition-api";
import { AutocompleteResult } from "@/components/Autocomplete/autocomplete-id";
import { Client, PhoneNumber } from "@/store/modules/clients";

interface hasClientId {
  client_id: string;
}

export const enum PhoneNumberClassification {
  cell = "cell",
  business = "business",
  home = "home",
}

const prettifiedPhoneNumberClassification = {
  cell: "Cell",
  business: "Business",
  home: "Home",
};

export const prettifyPhoneNumberClassification = (
  c: PhoneNumberClassification,
) => {
  return prettifiedPhoneNumberClassification[c];
};

export const phoneNumberClassificationReverseLookup = <
  { [key: string]: PhoneNumberClassification }
>{
  cell: PhoneNumberClassification.cell,
  business: PhoneNumberClassification.business,
  home: PhoneNumberClassification.home,
};

export const enum ClientStatus {
  active = "active",
  archived = "archived",
}

const prettifiedClientStatus = {
  active: "Active",
  archived: "Archived",
};

export const prettifyClientStatus = (s: ClientStatus) => {
  return prettifiedClientStatus[s];
};

export const clientStatusReverseLookup = <{ [key: string]: ClientStatus }>{
  active: ClientStatus.active,
  archived: ClientStatus.archived,
};

export function buildFormClientAutocomplete() {
  let formClient = reactive<AutocompleteResult>({
    id: "",
    label: "",
  });

  let updateClient = (
    evt: AutocompleteResult,
    formClient: AutocompleteResult,
    formData: hasClientId,
  ) => {
    formClient.id = evt.id;
    formClient.label = evt.label;
    formData.client_id = evt.id;
  };

  return {
    formClient,
    updateClient,
  };
}

export interface FormClientPhoneNumber extends PhoneNumber {
  _destroy: boolean;
}

export interface FormClient {
  id: string;
  name: string;
  manager: string;
  status: string;
  client_phone_numbers_attributes: FormClientPhoneNumber[];
}

export function buildFormClient() {
  let formClient = reactive<FormClient>({
    id: "",
    name: "",
    manager: "",
    status: "active",
    client_phone_numbers_attributes: [],
  });

  let loadEmptyPhoneNumber = (fc: FormClient) => {
    if (fc.client_phone_numbers_attributes.length === 0) {
      fc.client_phone_numbers_attributes = [
        {
          id: "",
          number: "",
          classification: "cell",
          sort_order: 100,
          _destroy: false,
        },
      ];
    }
  };

  let loadClientIntoForm = (cl: Client, fcl: FormClient) => {
    fcl.id = cl.id;
    fcl.name = cl.name;
    fcl.manager = cl.manager;
    fcl.status = cl.status;
    fcl.client_phone_numbers_attributes = cl.phone_numbers.map(item => {
      return {
        id: item.id,
        number: item.number,
        classification: item.classification,
        sort_order: item.sort_order,
        _destroy: false,
      };
    });
  };

  let phoneNumberClassifications = reactive<PhoneNumberClassification[]>([]);

  const loadPhoneNumberClassificationsIntoForm = (
    phClassifications: PhoneNumberClassification[],
  ) => {
    phClassifications.push(
      PhoneNumberClassification.cell,
      PhoneNumberClassification.business,
      PhoneNumberClassification.home,
    );
  };

  let clientStatuses = reactive<ClientStatus[]>([]);

  const loadClientStatusesIntoForm = (clStatuses: ClientStatus[]) => {
    clStatuses.push(ClientStatus.active, ClientStatus.archived);
  };

  return {
    clientStatuses,
    loadClientStatusesIntoForm,
    formClient,
    loadClientIntoForm,
    loadEmptyPhoneNumber,

    phoneNumberClassifications,
    loadPhoneNumberClassificationsIntoForm,
  };
}
